export default __webpack_public_path__ + "static/media/logo-white.06c976e6.png";